const BackToTop = ({ href = "#top", label = "Back to top" }) => {
  return (
    <a className="back-to-top" href={href} aria-label={label}>
      <i className="fa-solid fa-arrow-up" aria-hidden="true" />
    </a>
  );
};

export default BackToTop;
